import { API_KEY } from "./PndConstants";

/**
 * @typedef {Object} Coordinates
 * @property {number} latitude
 * @property {number} longitude
 */

/**
 * @typedef {Object} RouteData
 * @property {string} distance
 * @property {string} duration
 */

/**
 * Calculates time to pickup (TTP) between origin and destination.
 * @param {Coordinates} origin - The starting coordinates.
 * @param {Coordinates} destination - The destination coordinates.
 * @return {Promise<RouteData|null>} - The route data including distance and duration.
 */
export const calculateTTP = async (origin, destination) => {
    const apiKey = API_KEY;
    if (!apiKey) {
        console.warn('API key is missing');
        return null;
    }

    const url = `http://localhost:3007/api/directions?origin=${encodeURIComponent(`${origin.latitude},${origin.longitude}`)}&destination=${encodeURIComponent(`${destination.latitude},${destination.longitude}`)}&key=${encodeURIComponent(apiKey)}`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const responseData = await response.json();
        if (responseData.routes && responseData.routes.length > 0) {
            const route = responseData.routes[0];
            const leg = route.legs[0];
            const distance = leg.distance.value; // Distance in meters
            // Convert duration from seconds to minutes
            const durationInSeconds = leg.duration.value;
            const durationInMinutes = Math.ceil(durationInSeconds / 60);

            return {
                duration: durationInMinutes,
                distance,
            };
        } else {
            console.warn('No routes found');
            return null;
        }
    } catch (error) {
        console.error('Error while calling Google API:', error);
        return null;
    }
};
